import React from "react";
import { QRCodeSVG } from "qrcode.react";

interface GeneratorQRProps {
  code: string;
  description?: string;
}

const GeneratorQRCode: React.FC<GeneratorQRProps> = ({ code, description }) => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "20px",
        background: "#1a1a1a",
        borderRadius: "12px",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          padding: "16px",
          display: "inline-block",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
        }}
      >
        <QRCodeSVG
          value={code}
          size={200}
          bgColor={"#ffffff"}
          fgColor={"#000000"}
          level={"M"}
        />
      </div>

      <p style={{ color: "#aaa", marginTop: "10px", fontSize: "14px" }}>
        {description || "Aponte a câmera para ler"}
      </p>
    </div>
  );
};

export default GeneratorQRCode;
